import { render, staticRenderFns } from "./ManageStructureHeaderFooter.vue?vue&type=template&id=d0216f72&scoped=true"
import script from "./ManageStructureHeaderFooter.vue?vue&type=script&lang=js"
export * from "./ManageStructureHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0216f72",
  null
  
)

export default component.exports